<div class="product-carousel-container" *ngIf="products">
  <div class="content">
    <swiper
      [slidesPerView]="groupSize"
      [slidesPerGroup]="groupSize"
      [spaceBetween]="8"
      [navigation]="true"
      [loop]="true"
      [loopFillGroupWithBlank]="true"
      [pagination]="{ clickable: true }">
      <ng-template swiperSlide *ngFor="let product of products">
        <kion-product-card [product]="product" ></kion-product-card>
      </ng-template>
    </swiper>
  </div>
</div>
